import styled from "styled-components";

const ProgressBarContainer = styled.div``;

export { ProgressBarContainer };
